"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.string.small");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports["default"] = exports.Hide = exports.Base = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));

var _rebass = require("rebass");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var mapProps = function mapProps(map) {
  return function (Component) {
    return (0, _hoistNonReactStatics["default"])(function (props) {
      return _react["default"].createElement(Component, map(props));
    }, Component);
  };
};

var Base = (0, _styledComponents["default"])(_rebass.Box)(_styledSystem.display);
exports.Base = Base;
var Hide = mapProps(function (_ref) {
  var xsmall = _ref.xsmall,
      small = _ref.small,
      medium = _ref.medium,
      large = _ref.large,
      xlarge = _ref.xlarge,
      display = _ref.display,
      props = _objectWithoutPropertiesLoose(_ref, ["xsmall", "small", "medium", "large", "xlarge", "display"]);

  return _extends({
    display: display || [xsmall, small, medium, large, xlarge].map(function (n) {
      return n ? 'none' : 'block';
    })
  }, props);
})(Base);
exports.Hide = Hide;
var _default = Hide;
exports["default"] = _default;